export var IInsiderMembershipInformation;
(function (IInsiderMembershipInformation) {
    let State;
    (function (State) {
        State["STATE_UNKNOWN"] = "STATE_UNKNOWN";
        State["TRIALING"] = "TRIALING";
        State["ACTIVE"] = "ACTIVE";
        State["CANCELLED"] = "CANCELLED";
        State["UNPAID"] = "UNPAID";
        State["PAUSED"] = "PAUSED";
        /**
         * Excluded from insider due to experiment
         */
        State["NOT_ELIGIBLE"] = "NOT_ELIGIBLE";
        /**
         * Eligible but have never had insider -- will purchase free trial first
         */
        State["ELIGIBLE"] = "ELIGIBLE";
        State["AUTO_ENROLLED_TRIAL"] = "AUTO_ENROLLED_TRIAL";
    })(State = IInsiderMembershipInformation.State || (IInsiderMembershipInformation.State = {}));
    /**
     * Return an instance of IInsiderMembershipInformation with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IInsiderMembershipInformation.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IInsiderMembershipInformation || (IInsiderMembershipInformation = {}));
